import { Button, Dropdown } from 'antd';
import { ItemType } from 'antd/es/menu/interface';
import { ThreeDots } from 'assets';
import { messages } from 'messages';
import { CustomerGroupDto } from 'types';

type VipCustomerGroupActionsProps = {
  customerGroup: CustomerGroupDto;
  onDelete?: (customerGroup: CustomerGroupDto) => void;
};

const VipCustomerGroupActions = ({ customerGroup, onDelete }: VipCustomerGroupActionsProps) => {
  const actionItems: ItemType[] = [
    {
      key: 'delete',
      danger: true,
      label: messages.deleteButtonText
    }
  ];

  const onClickActionItem = (action: string, data: CustomerGroupDto) => {
    switch (action) {
      case 'delete':
        onDelete?.(data);
        break;
    }
  };

  return (
    <>
      <Dropdown
        trigger={['click']}
        menu={{
          items: actionItems,
          onClick: ({ key }) => {
            onClickActionItem(key, customerGroup);
          }
        }}
      >
        <Button type='text' shape='circle'>
          <ThreeDots />
        </Button>
      </Dropdown>
    </>
  );
};

export default VipCustomerGroupActions;
